import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = { class: "table-caption" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    class: "full-width",
    style: { "border-top": "1px solid #CCC" }
};
const _hoisted_6 = ["props", "onClick"];
const _hoisted_7 = { class: "col" };
const _hoisted_8 = { class: "row items-center justify-between q-pa-xs" };
const _hoisted_9 = { class: "text-grey" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "row items-center q-pa-sm" };
const _hoisted_12 = { style: { "overflow": "hidden", "text-overflow": "ellipsis" } };
const _hoisted_13 = {
    key: 0,
    class: "row justify-end text-grey"
};
const _hoisted_14 = { class: "row items-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_td = _resolveComponent("q-td");
    const _component_mypage_badge = _resolveComponent("mypage-badge");
    const _component_q_tr = _resolveComponent("q-tr");
    const _component_q_table = _resolveComponent("q-table");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.informationList }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
                                _createElementVNode("div", null, [
                                    _createVNode(_component_q_table, {
                                        rows: _ctx.result.response,
                                        columns: _ctx.columns,
                                        "row-key": "informationNo",
                                        "binary-state-sort": "",
                                        "hide-bottom": "",
                                        grid: _ctx.$q.screen.lt.md,
                                        "rows-per-page-options": [0]
                                    }, {
                                        body: _withCtx((props) => [
                                            _createVNode(_component_q_tr, {
                                                props: props,
                                                onClick: ($event) => (_ctx.onClick(props.row.informationNo))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_td, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            (props.row.weight)
                                                                ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                    key: 0,
                                                                    name: "info",
                                                                    size: "md",
                                                                    color: "red"
                                                                }))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_td, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            (props.row.isResponseRequired)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                                                    (props.row.isAnswered)
                                                                        ? (_openBlock(), _createBlock(_component_q_icon, {
                                                                            key: 0,
                                                                            name: "mark_email_read",
                                                                            size: "md",
                                                                            color: "grey"
                                                                        }))
                                                                        : (_openBlock(), _createBlock(_component_q_icon, {
                                                                            key: 1,
                                                                            name: "mark_email_unread",
                                                                            size: "md",
                                                                            color: "orange"
                                                                        }))
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_td, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(props.row.startAt), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_td, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(props.row.responseDeadline), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_td, { class: "text-left" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(props.row.subject), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_q_td, { class: "text-center" }, {
                                                        default: _withCtx(() => [
                                                            (!props.row.isReaded)
                                                                ? (_openBlock(), _createBlock(_component_mypage_badge, {
                                                                    key: 0,
                                                                    kbn: _ctx.readKbn,
                                                                    id: _ctx.readId
                                                                }, null, 8, ["kbn", "id"]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["props", "onClick"])
                                        ]),
                                        item: _withCtx((props) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", {
                                                    props: props,
                                                    onClick: ($event) => (_ctx.onClick(props.row.informationNo)),
                                                    class: "row"
                                                }, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        _createElementVNode("div", _hoisted_8, [
                                                            _createElementVNode("div", _hoisted_9, _toDisplayString(props.row.startAt), 1),
                                                            (!props.row.isReaded)
                                                                ? (_openBlock(), _createBlock(_component_mypage_badge, {
                                                                    key: 0,
                                                                    style: 'line-height: 15px; width: 70px;',
                                                                    kbn: _ctx.readKbn,
                                                                    id: _ctx.readId
                                                                }, null, 8, ["kbn", "id"]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_10, [
                                                            (props.row.weight)
                                                                ? (_openBlock(), _createBlock(_component_mypage_badge, {
                                                                    key: 0,
                                                                    style: 'line-height: 15px; width: 70px;',
                                                                    class: "q-mx-xs",
                                                                    kbn: _ctx.weightKbn,
                                                                    id: _ctx.weightid
                                                                }, null, 8, ["kbn", "id"]))
                                                                : _createCommentVNode("", true),
                                                            (props.row.isResponseRequired)
                                                                ? (_openBlock(), _createBlock(_component_mypage_badge, {
                                                                    key: 1,
                                                                    style: 'line-height: 15px; width: 70px;',
                                                                    class: "q-mx-xs",
                                                                    kbn: _ctx.responsesKbn,
                                                                    id: props.row.isAnswered ? _ctx.answered : _ctx.notAnswered
                                                                }, null, 8, ["kbn", "id"]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _createElementVNode("div", _hoisted_12, _toDisplayString(props.row.subject), 1)
                                                        ]),
                                                        (props.row.responseDeadline)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                                _createElementVNode("div", null, "回答期限：" + _toDisplayString(props.row.responseDeadline), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _createVNode(_component_q_icon, {
                                                            name: "chevron_right",
                                                            color: "grey",
                                                            "aria-hidden": "true"
                                                        })
                                                    ])
                                                ], 8, _hoisted_6)
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["rows", "columns", "grid"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
